import { render, staticRenderFns } from "./TeacherMessageForm.vue?vue&type=template&id=baf94ed0&scoped=true&"
import script from "./TeacherMessageForm.vue?vue&type=script&lang=js&"
export * from "./TeacherMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMessageForm.vue?vue&type=style&index=0&id=baf94ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf94ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
